module.exports = __webpack_public_path__ + "img/xero-inactive-odd-line.30df6a59.svg";